import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'
import { ContentType } from '../../shared/Globals';


const FBContent: React.FC<{ content?: string, contentType: ContentType }> = ({ content, contentType }) => {
    const summaryMd = content || "";

    if (contentType === ContentType.HTML) return <div dangerouslySetInnerHTML={{ __html: summaryMd }} />

    return <ReactMarkdown remarkPlugins={[remarkGfm]} children={summaryMd} />
}


export default FBContent